<section class="content">

  <img src="/assets/images/football/edge-football-logo.svg">

  <h1>From first downs to touchdowns!<br>
      Get the <span class="gaetitle">GoArmy Edge</span> app to view this item</h1>

  <section class="app-downloads">
      <edge-global-app-downloads
        sport="Football"
        sportLinkApple="//itunes.apple.com/us/app/goarmy-edge-football/id968154309"
        sportLinkGoogle=""
        sportLinkWindows="">
      </edge-global-app-downloads>
    </section>
</section>